import Placeholder from "@casino/server/components/Placeholder";
import gameAreaBoxClasses from "@casino/ui/Games/gameAreaBoxClasses";
import type { ComponentProps, FC } from "react";

type Props = ComponentProps<"div">;

const GameAreaPlaceholder: FC<Props> = ({ className, ...props }) => (
  <div
    aria-busy="true"
    data-testid="game-area-placeholder"
    className={`${gameAreaBoxClasses} overflow-hidden rounded-lg ${className ?? ""}`}
    {...props}
  >
    <Placeholder />
  </div>
);

export default GameAreaPlaceholder;
